import React, { useState } from "react";
import axios from "axios";

const Footer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [termsContent, setTermsContent] = useState("");

  const fetchTerms = async (type) => {
    try {
      const response = await axios.get(
        "https://www.medicode.co.kr:8445/api/get/footer_terms",
        {
          params: { type },
        }
      );
      setTermsContent(response.data[0].contents);
      console.log(response);
    } catch (error) {
      console.error("Error fetching terms:", error);
    }
  };

  const openModal = (type) => {
    fetchTerms(type);
    setModalOpen(true);
    document.body.style.overflow = "hidden"; // Y축 스크롤 막기
  };

  const closeModal = () => {
    setModalOpen(false);
    document.body.style.overflow = "auto"; // Y축 스크롤 복원
  };

  return (
    <footer id="footer">
      <div className="footer-inner">
        <div className="footer-left-wrap">
          <p className="first-content">
            <span onClick={() => openModal(1)} style={{ cursor: "pointer" }}>
              이용약관
            </span>{" "}
            &nbsp;| &nbsp;
            <span onClick={() => openModal(2)} style={{ cursor: "pointer" }}>
              개인정보처리방침
            </span>
          </p>
          <p className="second-content">
            <span>(주)메디코드</span> | 경기도 화성시 향남읍 만년로 192-32
          </p>
          <p className="third-content">
            Business registration no. 674-86-03103
          </p>
          <p className="third-content">
            <span>Tel.</span> 0507-1394-5706 &nbsp;&nbsp;<span>Email.</span>{" "}
            CS@medicode.co.kr
          </p>
          <p className="fourth-content">
            <span>ⓒ</span> 2025 MEDICODE All rights reserved.
          </p>
        </div>
        <div className="footer-right-wrap">
          <div className="main-logo"></div>
        </div>
      </div>
      {modalOpen && (
        <Modal
          contents={termsContent}
          onClose={closeModal}
          modalOpen={modalOpen}
        />
      )}
    </footer>
  );
};

// 모달 컴포넌트
const Modal = ({ contents, onClose, modalOpen }) => {
  return (
    <div
      className={`modal-overlay ${modalOpen ? "open" : ""}`}
      onClick={onClose}
    >
      <div
        className={`modal-content ${modalOpen ? "open" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="close-btn-wrap">
          <div className="policy-img"></div>
          <button className="modal-close" onClick={onClose}>
            X
          </button>
        </div>
        <div
          className="modal-body"
          dangerouslySetInnerHTML={{ __html: contents }}
        />
      </div>
    </div>
  );
};
export default Footer;
